import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const radioGroupDefaultVariants = {
  "size": "md"
}
const radioGroupCompoundVariants = [
  {
    "variant": "rounded",
    "size": "sm",
    "css": {
      "root": {
        "gap": {
          "_vertical": "2",
          "_horizontal": "2"
        }
      }
    }
  },
  {
    "variant": "rounded",
    "size": "md",
    "css": {
      "root": {
        "gap": {
          "_vertical": "3",
          "_horizontal": "3"
        }
      }
    }
  },
  {
    "variant": "rounded",
    "size": "lg",
    "css": {
      "root": {
        "gap": {
          "_vertical": "4",
          "_horizontal": "4"
        }
      }
    }
  }
]

const radioGroupSlotNames = [
  [
    "root",
    "radioGroup__root"
  ],
  [
    "label",
    "radioGroup__label"
  ],
  [
    "item",
    "radioGroup__item"
  ],
  [
    "itemText",
    "radioGroup__itemText"
  ],
  [
    "itemControl",
    "radioGroup__itemControl"
  ],
  [
    "indicator",
    "radioGroup__indicator"
  ]
]
const radioGroupSlotFns = /* @__PURE__ */ radioGroupSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, radioGroupDefaultVariants, getSlotCompoundVariant(radioGroupCompoundVariants, slotName))])

const radioGroupFn = memo((props = {}) => {
  return Object.fromEntries(radioGroupSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const radioGroupVariantKeys = [
  "variant",
  "size"
]
const getVariantProps = (variants) => ({ ...radioGroupDefaultVariants, ...compact(variants) })

export const radioGroup = /* @__PURE__ */ Object.assign(radioGroupFn, {
  __recipe__: false,
  __name__: 'radioGroup',
  raw: (props) => props,
  variantKeys: radioGroupVariantKeys,
  variantMap: {
  "variant": [
    "rounded"
  ],
  "size": [
    "sm",
    "md",
    "lg"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, radioGroupVariantKeys)
  },
  getVariantProps
})